// extracted by mini-css-extract-plugin
export var active = "_rr-1";
export var circle = "_rr-0";
export var completed = "_rr-2";
export var connector = "_rr-4";
export var connectorCompleted = "_rr-7";
export var connectorSpacer = "_rr-5";
export var iconStrokeOverride = "_rr-8";
export var labelContainer = "_rr-6";
export var pending = "_rr-3";